import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/promotions/src/hooks';
import { useOffer, UseOfferProps } from '../useOffer';

import { activeOfferQuery as ActiveOfferResult } from './types/activeOfferQuery';

export const activeOfferQuery = gql`
  query activeOfferQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      activeOfferId
    }
  }
`;

/**
 * Returns data and actions for the account's active offer, if there is one.
 */
export const useActiveOffer = (
  props: Partial<Omit<UseOfferProps, 'offerId'>> = {}
) => {
  const { accountId } = useCurrentAccountId();

  const { data, loading } = useQuery<ActiveOfferResult>(activeOfferQuery, {
    skip: !accountId,
    variables: {
      accountId,
    },
  });

  const useOfferResult = useOffer({
    ...props,
    offerId: data?.account?.activeOfferId,
  });

  return {
    activeOffer: useOfferResult.offer,
    error: useOfferResult?.error,
    activeOfferEndDate: useOfferResult.offerEndDate,
    isLoading: loading || useOfferResult?.isLoading,
  };
};

export const useActiveOfferMock = {
  request: { query: activeOfferQuery },
  result: {
    data: {
      account: {
        __typename: 'Account',
        id: '1',
        activeOfferId: '1',
      },
    },
  },
};
